import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PropTypes from 'prop-types';
import { whiteColor, blackColor } from 'common/assets/jss/appStyle';

function QRCode({ qrId }) {
  return (
    <QRCodeSVG
      value={qrId}
      size={200}
      bgColor={whiteColor}
      fgColor={blackColor}
      level="H"
    />
  );
}

QRCode.propTypes = {
  qrId: PropTypes.string.isRequired,
};
export default QRCode;
